import React from "react";
import { paramProps } from "@/types/common";
import { Link } from "@reach/router";
import { useDesign } from "@hooks";

const TopComponent: React.FC<paramProps> = ({ evseID }) => {
  const { data: design } = useDesign(evseID ? { evseID } : null);

  return (
    <>
      <div className="dark:hidden block max-w-lg border-gray-200 px-2 sm:px-4 py-2.5 rounded">
        <div className="container flex flex-wrap items-left mx-auto">
          {design?.darkLogo ? (
            <div className="">
              <Link to={"/con/" + evseID} className="">
                <img id="logo" className="main-logo" src={design?.darkLogo} alt={design?.cpoName} title={design?.cpoName} height={70} />
              </Link>
            </div>
          ) : (
            <span className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
              {design?.cpoName === "" ? "Adhoc-Charge" : design?.cpoName}
            </span>
          )}
        </div>
      </div>

      <div className="hidden dark:block max-w-lg px-2 sm:px-4 py-2.5 rounded ">
        <div className="container flex flex-wrap items-left mx-auto">
          {design?.lightLogo ? (
            <div className="">
              <Link to={"/con/" + evseID} className="">
                <img id="logo" className="main-logo" src={design?.lightLogo} alt={design?.cpoName} title={design?.cpoName} height={70} />
              </Link>
            </div>
          ) : (
            <span className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
              {design?.cpoName === "" ? "Adhoc-Charge" : design?.cpoName}
            </span>
          )}
        </div>
      </div>
    </>
  );
};
export default TopComponent;
